<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
	<p>{{data.content}}</p>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="dialogResult.YES" autofocus>Yes</button>
	<button mat-button [mat-dialog-close]="dialogResult.NO">No</button>
</div>